import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { Input, Label, Table } from 'reactstrap';
import Header from '../../components/header/Header';
import { PreferencesStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Footer from '../../components/footer/Footer';
import Logo from '../../components/assets/omint-pride.svg';
import imageSource from '../../components/assets/preferencias.webp';
import ProgressBar from '../../components/status/ProgressBar';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormPreferences = () => {
  const [progress, setProgress] = useState(4);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const [preferences, setPreferences] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    sessionStorage.setItem('@preferencesData', JSON.stringify({ preferences }));
  }, [preferences]);

  const handlePreferences = (e) => {
    setPreferences(e.target.value);
  };

  return (
    <>
      <PreferencesStyle>
        <div className="preferences__wrapper">
          <div className="container">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>

            <div className="content__wrapper">
              <h1 className="title">
                Possui alguma preferência em hospitais, laboratórios ou região
                de atendimento?
              </h1>

              <div className="question__wrapper">
                <p className="text" onClick={toggleDropdown}>
                  Por que precisamos desses dados?{' '}
                  <img
                    className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                    src={cornerRightArrow}
                    alt="Saiba mais"
                  />
                </p>

                <p
                  className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}
                >
                  Isso nos ajuda a comparar os melhores planos de saúde com os
                  seus hospitais de preferência!
                </p>
              </div>
            </div>

            <div className="inputs__wrapper">
              <div className="input_container">
                <Label htmlFor="preferences">Digite suas preferências</Label>
                <Input
                  type="textarea"
                  name="preferences"
                  className="no-resize"
                  id="preferences"
                  placeholder="Hospitais, laboratórios, região de atendimento..."
                  value={preferences}
                  onChange={handlePreferences}
                />
              </div>
            </div>
            <p className="footer-note">Caso não tenha, clique em "Continuar"</p>
          </div>
          <ProgressBar progress={progress} steps={5} />
        </div>
        <Footer />
      </PreferencesStyle>
    </>
  );
};

export default FormPreferences;
